module.exports = __webpack_public_path__ + "media/brand/PhotosByArtkiveLogo-0d528b5f.png";